import axios from 'axios';
import * as Url from '../api/url';
// TODO: Make functional + use TaskEither
export const getSavedConfiguration = async (serviceUrls, sharedConfiguratorId) => {
    const url = Url.toString({
        base: serviceUrls.layouts,
        path: `/configurations/${sharedConfiguratorId}`,
        query: {},
    });
    return await axios.get(url);
};
